import React from 'react';
const features = [{
  title: 'Advanced set plays diagrams',
  desc: 'Full-court diagrams for the time-out.'
}, {
  title: 'Professional movement patterns',
  desc: 'Ready-made plays for every game situation.'
}, {
  title: 'Game-day cheat sheets',
  desc: 'Silent communication with your team.'
}, {
  title: 'Video scouting guide',
  desc: 'Analyze your opponent from your phone in minutes.'
}, {
  title: 'Individual breakdowns',
  desc: 'History, metrics and personal goals.'
}, {
  title: 'Advanced match reports',
  desc: 'Documents ready to hand over.'
}];
export function EliteSection() {
  return <section className="w-full bg-[#0A0A0A] py-20 px-4" data-id="element-35">
      <div className="max-w-4xl mx-auto" data-id="element-36">
        <div className="text-center mb-12" data-id="element-37">
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-38">
            Tactical Playbook <span className="text-[#6B2FB3]" data-id="element-39">Pro</span>
          </h2>
          <p className="text-[#B0B0C0] text-lg sm:text-xl font-medium max-w-2xl mx-auto" data-id="element-40">
            The system that makes every coach look like a professional
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-41">
          {features.map((f, i) => <div key={i} className="bg-[#16161F] border border-[#6B2FB333] rounded-2xl p-5 flex items-start gap-4" data-id="element-42">
              <span className="text-[#00C853] text-xl flex-shrink-0 mt-0.5" data-id="element-43">
                ✅
              </span>
              <div data-id="element-44">
                <h4 className="text-white font-bold text-base mb-1" data-id="element-45">
                  {f.title}
                </h4>
                <p className="text-[#B0B0C0] text-sm font-medium leading-relaxed" data-id="element-46">
                  {f.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}